var SERVER_IP = "http://127.0.0.1:27016";
var supported_device = { SECUGEN: 1, CENTERM: 2 };
var conf = {};
var BO;


/*
FingerNames

Right Thumb : right_thumb
Right index : right_index
Right middle : right_middle
Right ring : right_ring
Right little : right_little
left Thumb : left_thumb
left index : left_index
left middle : left_middle
left ring : left_ring
left little : left_little
UnknownFinger : unknown


*/

function tx_deviceInit(device) {
  if (device == supported_device.SECUGEN) {
    conf['conf'] = {};
    conf['conf']['quality'] = 50;
    conf['conf']['timeout'] = 10000;
    conf['fingerName'] = "right_thumb";
  } else if (device == supported_device.CENTERM) {
    conf['conf'] = {};
    conf['conf']['timeout'] = 60; //seconds
  }
}

function tx_deviceGet(device, successFucntion, ErrorFunction, async_flag, ctx) {
  if (device == supported_device.SECUGEN) {
    try{
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        successFucntion(this.responseText, ctx);
      }
      if (this.readyState == 4 && this.status != 200) {
        ErrorFunction(this);
      }
    };
    xhttp.open("POST", SERVER_IP + "/secugen", async_flag);
    xhttp.send(JSON.stringify(conf));
  }
    catch (e) {
      ErrorFunction(e);
    }
  } else if (device == supported_device.CENTERM) {
    try {
      var xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          var data = JSON.parse(this.responseText);
          successFucntion(data, ctx);
        }
        if (this.readyState == 4 && this.status != 200) {
          ErrorFunction(this);
        }
      };
      xhttp.open("POST", SERVER_IP + "/centerm", async_flag);
      xhttp.send(JSON.stringify(conf));
    } catch (e) {
      ErrorFunction(e);
    }
  }
}
